import { z } from 'zod';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
export const CurrentMultiUserProfile = z.object({
    id: z.string().uuid(),
    username: z.string().refine(isEmail, { message: 'Has to be an email' }),
    data: z.object({
        profile: z.object({
            firstName: z.string(),
            lastName: z.string(),
            phoneNumber: z.string().refine(isMobilePhone, { message: 'Has to be a phone number' }).optional(),
            icon: z.string().url().optional(),
        }).strict(),
    }).strict(),
}).strict();
//# sourceMappingURL=schemas.js.map